import { render, staticRenderFns } from "./NewTopicModal.vue?vue&type=template&id=7b642943&scoped=true&"
import script from "./NewTopicModal.vue?vue&type=script&lang=js&"
export * from "./NewTopicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b642943",
  null
  
)

export default component.exports